import TabOptions from '../options';

export class Model {
  referralInfo = {
    referralDate: null,
    studentIdentity: {},
    schoolInfo: {},
    addressInfo: {},
    emergencyContactInfo: {},
    disabilityMedicalInfo: {
      disabilityCategory: null,
      diagnosis: null,
      diagnosisSpecification: null,
      diagnoses: [],
      isReceivingTreatment: null,
      treatmentDescription: null,
      usesMedication: null,
      medicationDescription: null,
      walksIndependently: null,
      usesAssistiveEquipment: null,
      assistiveEquipmentDescription: null,
      canTravelAlone: null,
      travelAloneDescription: null,
      performsDailySelfCareActivities: null,
    },
    educationalHistoryInfo: {
      isCurrentlyStudying: null,
      completedGradeProgram: null,
      vocationalOccupationalTraining: null,
      otherAcademicExperiences: null,
      studentVocationalInterest: null,
      hasVocationalInterestEvaluationReport: null,
      vocationalInterestEvaluationDocumentType:
        'Copia del Informe de Apreciación o Evaluación',
      vocationalInterestEvaluationFile: null,
      vocationalInterestEvaluationDocumentDeleted: false,
      isWillingToCompleteVocationalGoal: null,
    },
    additionalInformation: {
      commonEmploymentSourcesResidentialArea: null,
      availableTransportation: null,
      otherComments: null,
      referralReason: null,
    },
  };
}

export class Tab {
  id = 'ReferralInfo';
  title = 'Información del Referido';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = ({ referralInfo }) => {
    const {
      vocationalInterestEvaluationDocument,
      vocationalInterestEvaluationDocumentType,
      vocationalInterestEvaluationFile,
      ...educationalHistoryInfo
    } = referralInfo.educationalHistoryInfo || {};
    const {
      diagnosis,
      diagnosisSpecification,
      diagnoses,
      ...disabilityMedicalInfo
    } = referralInfo.disabilityMedicalInfo || {};

    return {
      tab: 'Information',
      referralDate: referralInfo.referralDate,
      ...disabilityMedicalInfo,
      diagnoses: (diagnoses || []).map((x, index) => ({
        id: x.id || null,
        diagnosisId: x.diagnosisId || x.id,
        name: x.name,
        other: x.other || null,
        sortOrder: index + 1,
      })),
      ...educationalHistoryInfo,
      ...referralInfo.additionalInformation,
      vocationalInterestEvaluationFile,
    };
  };
}
export default new Tab();
